import React from 'react'
import { Select } from 'antd'
import { observer } from 'mobx-react'
import { store } from '../../../../store'
import { profileService } from '../../../../services/ProfileService'
import styles from './BusinessSelector.module.scss'

export const BusinessSelector = observer(() => {
  const businessData = store.profile.profile?.businessData
  if (!businessData) { return null }

  const businessIds = Object.keys(businessData)
  return (
    <div className={styles.root}>
      <Select
        dropdownMatchSelectWidth
        className={styles.select}
        defaultValue={store.profile.businessId}
        onChange={profileService.setBusinessId}
        options={businessIds.map(i => ({ value: i, label: businessData[i].name }))}
      />
    </div>
  )
})
